export const whatDoWeDo = {
	title: 'Čo robíme',
	ourProjects: 'Naše projetky',
	items: [
		[
			{text: 'Umelé osvetlenie', image: '/img/public/whatDoWeDo/icons/umeleOsvetlenie.svg'},
			{text: 'Verejné osvetlenie', image: '/img/public/whatDoWeDo/icons/verejneOsvetlenie.svg'},
			{text: 'Elektrické inštalácie', image: '/img/public/whatDoWeDo/icons/elektrickeInstalacie.svg'},
			{text: 'Trafostanice', image: '/img/public/whatDoWeDo/icons/trafostanice.svg'},
		],
		[
			{text: 'Líniové stavby - NN, VN', image: '/img/public/whatDoWeDo/icons/linioveStavby.svg'},
			{text: 'Štruktúrované kabeláže', image: '/img/public/whatDoWeDo/icons/strukturovaneKabelaze.svg'},
			{text: 'Optické siete', image: '/img/public/whatDoWeDo/icons/optickeSiete.svg'},
			{text: 'EZS', image: '/img/public/whatDoWeDo/icons/ezs.svg'},
		],
		[
			{text: 'OPaOS, analýza siete', image: '/img/public/whatDoWeDo/icons/opaos.svg'},
			{text: 'CCTV', image: '/img/public/whatDoWeDo/icons/cctv.svg'},
			{text: 'EPS', image: '/img/public/whatDoWeDo/icons/eps.svg'},
			{text: 'HSP', image: '/img/public/whatDoWeDo/icons/hsp.svg'},
		],
	],
};
